import { errorToast } from "@/v2-ui/toast"
import {
  type ConfirmButtonProps,
  ConfirmButton,
} from "@/v2-backoffice-client/components/button"
import { useUptimeConfigCategoryDeleteMutation } from "@/v2-backoffice-client/uptime/configCategory/delete/uptime.configCategory.delete.mutation"

export type UptimeConfigCategoryDeleteButtonProps = Omit<
  ConfirmButtonProps,
  "onConfirm"
> & {
  categoryId: string
  onCompleted?(): void
}

function UptimeConfigCategoryDeleteButton(
  props: UptimeConfigCategoryDeleteButtonProps,
) {
  const { categoryId, onCompleted, ...buttonProps } = props

  const [del, { loading, error }] = useUptimeConfigCategoryDeleteMutation({
    onCompleted,
  })
  errorToast(error ?? null, { title: "Failed to delete category" })

  return (
    <ConfirmButton
      variant="ghost"
      size="sm"
      iconSrc="trash"
      content="Delete category"
      confirmContent="Delete category? Sources are removed too."
      isLoading={loading}
      onConfirm={async () => {
        await del({ variables: { id: categoryId } })
      }}
      {...buttonProps}
    />
  )
}

export default UptimeConfigCategoryDeleteButton
